import React, { useState, useEffect } from 'react';
import { List, Divider, IconButton, Grid, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Alert } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { supabase, host } from '../../../supabaseClient';

const RewardsList = ({ companyId, canEdit }) => {
  const [rewards, setRewards] = useState([]);
  const [selectedReward, setSelectedReward] = useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

  const fetchRewards = async () => {
    try {
      const { data, error } = await supabase
        .from('rewards')
        .select('*')
        .eq('company', companyId);

      if (error) {
        throw error;
      }

      setRewards(data);
    } catch (error) {
      console.error('Error fetching rewards:', error.message);
    }
  };

  const deleteReward = async (rewardId) => {
    try {
      const { error } = await supabase
        .from('rewards')
        .delete()
        .eq('id', rewardId);

      if (error) {
        throw error;
      }

      // Remove the deleted reward from the rewards state
      const newRewards = rewards.filter((reward) => reward.id !== rewardId);
      setRewards(newRewards);
    } catch (error) {
      console.error('Error deleting reward:', error.message);
    } finally {
      closeConfirmDelete();
    }
  };

  const openConfirmDelete = (reward) => {
    setSelectedReward(reward);
    setConfirmDeleteOpen(true);
  };

  const closeConfirmDelete = () => {
    setSelectedReward(null);
    setConfirmDeleteOpen(false);
  };

  useEffect(() => {
    fetchRewards();
  }, [companyId]);

  if (rewards.length === 0) {
    return (
      <Alert severity="info" sx={{ mt: 2 }}>
        Aún no tienes recompensas.
      </Alert>
    );
  }

  return (
    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
      {rewards.map((reward, index) => (
        <React.Fragment key={index}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <img src={`${host}/storage/v1/object/public/rewards/${companyId}/${reward.id}.png`} alt={reward.name} width="50" height="50" />
            </Grid>
            <Grid item xs={7}>
              <Typography variant="subtitle1">{reward.name}</Typography>
              <Typography variant="body2">Puntuación para desbloquarlo: {reward.score}</Typography>
            </Grid>
            {canEdit && (
              <Grid item xs={2}>
                <IconButton
                  onClick={() => openConfirmDelete(reward)}
                  aria-label="delete"
                  color="error"
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            )}
          </Grid>
          <Divider light />
        </React.Fragment>
      ))}

      {/* Confirm Delete Dialog */}
      <Dialog open={confirmDeleteOpen} onClose={closeConfirmDelete}>
        <DialogTitle>Confirmar Eliminación</DialogTitle>
        <DialogContent>
          {selectedReward && (
            <p>¿Estás seguro de que deseas eliminar la recompensa?</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirmDelete}>Cancelar</Button>
          <Button onClick={() => deleteReward(selectedReward?.id)} color="error">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </List>
  );
};

export default RewardsList;
